import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AdminService } from "../admin.service";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-admin-notification-approve",
  templateUrl: "./admin-notification-approve.component.html",
  styleUrls: ["./admin-notification-approve.component.css"],
})
export class AdminNotificationApproveComponent implements OnInit {
  token: any;
  statusAvailable: any = "available";
  loading: boolean = false;
  loginStatus: any = "approve";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private matdialogref: MatDialogRef<AdminNotificationApproveComponent>,
    private services: AdminService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {}

  close() {
    this.matdialogref.close();
  }
  approve() {
    this.loading = true;
    if (this.data.loginInfo[0].user_type == "driver") {
      this.services
        .updateStatus(
          this.token,
          this.statusAvailable,
          this.data.loginInfo[0].user_type,
          this.data.loginInfo[0]?.ref_id
        )
        .subscribe((response: any) => {
          this.close();
          location.reload();
          this.snackBar.open("Driver Approved", "Success", {
            duration: 5000,
          });
        });
    }

    if (this.data.loginInfo[0].user_type == "truckowner") {
      this.services
        .updateStatus(
          this.token,
          this.statusAvailable,
          this.data.loginInfo[0].user_type,
          this.data.loginInfo[0]?.ref_id
        )
        .subscribe((response: any) => {
          this.close();
          location.reload();
          this.snackBar.open("Truck owner Approved", "Success", {
            duration: 5000,
          });
        });
    }
  }
}
